import refundServiceChargeTaskTracking from './view/refundServiceChargeTaskTracking.html'

export default {
  base: {
    state: 'declaration.personalIncomeTax.refundServiceChargeTaskTracking',
    config: {
      url: '/refundServiceChargeTaskTracking',
      abstract: true,
      template: '<div ui-view></div>',
      default: 'declaration.personalIncomeTax.refundServiceChargeTaskTracking.list',
      title: '退付手续费任务跟踪',
    },
  },
  list: {
    state: 'declaration.personalIncomeTax.refundServiceChargeTaskTracking.list',
    config: {
      url: '/list',
      template: refundServiceChargeTaskTracking,
      controller: 'refundServiceChargeTaskTrackCtrl',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/declaration/personalIncomeTax/refundServiceChargeTaskTracking/routers.js